// Base theme
export interface ThemeType {
    colors: {
        primary: string;
        secondary: string;
        background: string;
        surface: string;
        text: string;
        textSecondary: string;
        border: string;
        success: string;
        warning: string;
        error: string;
        shadow: string;
    };
    spacing: {
        xs: number;
        sm: number;
        md: number;
        lg: number;
        xl: number;
    };
    borderRadius: {
        sm: number;
        md: number;
        lg: number;
        xl: number;
        full: number;
    };
    fontSize: {
        xs: number;
        sm: number;
        md: number;
        lg: number;
        xl: number;
        xxl: number;
    };
}

export const baseTheme: ThemeType = {
    colors: {
        primary: '#e74c3c',       // Bold red
        secondary: '#f39c12',     // Vibrant orange
        background: '#1c1c1e',    // Deep charcoal
        surface: '#2c2c2e',       // Dark gray
        text: '#ffffff',          // Pure white
        textSecondary: '#8e8e93', // Steel gray
        border: '#48484a',        // Medium gray
        success: '#27ae60',       // Strong green
        warning: '#f1c40f',       // Electric yellow
        error: '#e74c3c',         // Same as primary - bold red
        shadow: '#00000060',      // Strong shadow
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 16,
        lg: 24,
        xl: 32,
    },
    borderRadius: {
        sm: 4,
        md: 8,
        lg: 12,
        xl: 16,
        full: 9999,
    },
    fontSize: {
        xs: 12,
        sm: 14,
        md: 16,
        lg: 18,
        xl: 24,
        xxl: 32,
    },
};
